import { render, staticRenderFns } from "./AuthorPassageConfirmDialog.vue?vue&type=template&id=0c869eca&scoped=true"
import script from "./AuthorPassageConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./AuthorPassageConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./AuthorPassageConfirmDialog.vue?vue&type=style&index=0&id=0c869eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c869eca",
  null
  
)

export default component.exports